import { attr } from '@ember-data/model';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import { fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
export default EmberDataBaseFragment.extend({
  uid: attr('string'),
  name: attr('string'),
  basePriceMoney: attr('subscriptions/order-money'),
  grossSalesMoney: attr('money-proto', {
    readOnly: true
  }),
  totalMoney: attr('money-proto', {
    readOnly: true
  }),
  appliedTaxes: fragmentArray('applied-tax', {
    defaultValue: []
  }),
  quantity: attr('string'),
  // expected as string by backend
  itemVariationId: attr('string'),
  // the item variation actually subscribed to
  itemId: attr('string'),
  // the parent item
  catalogVersion: attr('number'),
  // the version of the item
  variationName: attr('string', {
    readOnly: true
  }),
  modifiers: fragmentArray('subscription-line-item-modifier', {
    defaultValue: []
  }),
  note: attr('string'),
  pricingBlocklists: fragment('pricing-blocklists', {
    defaultValue: {}
  })
}).reopenClass({
  _modelNameForMigration: 'subscription-order-line-item'
});